var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ConsigneeShipperAndNotifyAddress"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "100%", "margin-bottom": "5px" },
          attrs: { "label-width": "120px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                      }
                    },
                    [
                      _vm.fba
                        ? _c("cargo-company-select", {
                            staticClass: "shipper-selector",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "customerId",
                              "popper-class": "shipper-selector-popper",
                              "method-params": {
                                customer: true,
                                active: true,
                                fba: true
                              },
                              "check-credit": true,
                              job: _vm.job,
                              "default-value": _vm.job.customerId || "",
                              "static-options": _vm.customerCmpList,
                              "data-filter-function": _vm.customerIdFilter
                            },
                            on: {
                              change: function(p) {
                                _vm.filter.partnerId = p.value
                              }
                            }
                          })
                        : _c("cargo-company-select", {
                            attrs: {
                              "method-params": { customer: true },
                              "default-value": _vm.filter.partnerId || "",
                              no: "1"
                            },
                            on: {
                              change: function(p) {
                                _vm.filter.partnerId = p.value
                              }
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Destination") } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          options: _vm.destinations,
                          filterable: "",
                          clearable: true,
                          no: "2"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.JobUtils.focusWarehouseCode(_vm.filter)
                          },
                          blur: function($event) {
                            return _vm.JobUtils.blurWarehouseCode(_vm.filter)
                          },
                          change: function(p) {
                            _vm.JobUtils.warehouseCodeHandler(_vm.filter, p)
                          }
                        },
                        model: {
                          value: _vm.filter.warehouseCode,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "warehouseCode", $$v)
                          },
                          expression: "filter.warehouseCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "3" },
                      on: { click: _vm.toQuery }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "4" },
                      on: { click: _vm.reset }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ShipperSName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "5" },
                        model: {
                          value: _vm.filter.shipperEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "shipperEnterpriseName", $$v)
                          },
                          expression: "filter.shipperEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_ConsigneeSName") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "6" },
                        model: {
                          value: _vm.filter.consigneeEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "consigneeEnterpriseName", $$v)
                          },
                          expression: "filter.consigneeEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_NotifyPartySName")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "7" },
                        model: {
                          value: _vm.filter.notifyEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "notifyEnterpriseName", $$v)
                          },
                          expression: "filter.notifyEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          },
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "8" },
              on: {
                click: function($event) {
                  return _vm.choose(["shipperInfo"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyShipper")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "9" },
              on: {
                click: function($event) {
                  return _vm.choose(["consigneeInfo"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyConsignee")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "10" },
              on: {
                click: function($event) {
                  return _vm.choose(["notifyInfo"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyNotify")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "11" },
              on: {
                click: function($event) {
                  return _vm.choose([
                    "shipperInfo",
                    "consigneeInfo",
                    "notifyInfo"
                  ])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "12" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }